import { render, staticRenderFns } from "./FieldCustomerDeliveryAddress.vue?vue&type=template&id=c37d127a&"
import script from "./FieldCustomerDeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerDeliveryAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports